/* globals document */

import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import Content from './Content/Content';
import { ModalWrapper, Overlay, ContentWrapper } from './style';
var Modal = function Modal(props) {
  var id = props.id,
    children = props.children,
    animation = props.animation,
    withOutsideClose = props.withOutsideClose,
    withFrame = props.withFrame,
    onClose = props.onClose,
    showCloseIcon = props.showCloseIcon,
    maxWidth = props.maxWidth;
  var el = document.createElement('div');
  useEffect(function () {
    var modalRoot = document.createElement('div');
    modalRoot.setAttribute('id', "".concat(id, "-modal-root"));
    document.body.appendChild(modalRoot);
    modalRoot.appendChild(el);
    return function () {
      document.body.removeChild(modalRoot);
    };
  }, [el, id]);
  return el ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(ModalWrapper, null, /*#__PURE__*/React.createElement(Overlay, null), /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(Content, {
    animation: animation,
    withOutsideClose: withOutsideClose,
    withFrame: withFrame,
    onClose: onClose,
    showCloseIcon: showCloseIcon,
    maxWidth: maxWidth
  }, children))), el) : null;
};
Modal.defaultProps = {
  id: 'unset',
  animation: 'fadeIn',
  withFrame: true,
  showCloseIcon: true
};
Modal.displayName = 'Modal';
export default Modal;